import React, { Component, Fragment } from 'react';
import PromotionDashboard from './PromotionDashboard';

const Promotion = () => {
    return (
        <PromotionDashboard />
    )
}

export default Promotion